import * as Cpa_en from './cpa.en.js';
import * as Cpa_es from './cpa.es.js';

const CpaTuple = [
  { type: 'Cpa', language: 'en', object: Cpa_en.default },
  { type: 'Cpa', language: 'es', object: Cpa_es.default },
];

export default CpaTuple;
